import { message, Space, Form as FormInitial, Row, Col } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem, ButtonItem, Form, FormItem, InputItem, ErrorItem,
} from "../../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import apartadoPdf from "../../../../../Pdf/apartadoPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class EnviarCorreoApartarVenta extends Component {
  formRef = React.createRef();
  state = { loading: false, pdf: null };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible && this.props.id) {
      this.consultarTodo();
    }
  }

  consultarTodo() {
    this.setState({ loading: true });
    axios
      .post(
        "ventas/datosApartadoPdf",
        {
          ventaId: this.props.id,
          empresaId: this.props.empresaId,
          insumosApartados: this.props.insumosApartados, 
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          if (res.data?.correosEnvio?.length > 0 && this.formRef.current) {
            this.formRef.current.setFieldsValue({ correosEnvio: res.data.correosEnvio });
          }
          const dd = apartadoPdf(res.data);
          const pdfDoc = pdfMake.createPdf(dd);
          this.setState({ loading: false, }, () => {
            pdfDoc.open({}, window.frames["apartadoPdf"]);
          });
        } else {
          this.setState({ loading: false });
          message.error("No se pudieron cargar los datos del apartado");
        }
      });
  }

  onFinishFailed(e) { ErrorItem(e); }

  onFinish(values) {
    if (!values?.correosEnvio?.length) {
      return message.info("Proporcione al menos un correo");
    }
    this.setState({ loading: true });
    axios
      .post(
        "ventas/enviarApartadoCorreo",
        {
          ...values,
          ventaId: this.props.id,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Apartado enviado");
          this.cerrarModal();
        } else {
          message.error("No se pudo enviar");
        }
      });
    }
    

  cerrarModal() {
    this.props.cerrarModal();
    this.formRef.current?.resetFields();
    this.setState({ pdf: null });
  }

  render() {
    return (
      <ModalItem
        title="Vista previa - Apartado"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal.bind(this)}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="correoApartado"
          layout
          width={700}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormInitial.List name="correosEnvio" initialValue={[{ correo: "" }]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={arrayKey}>
                    <Col span={22}>
                      <FormItem name={[name, "correo"]} fieldKey={[arrayKey, "correo"]}
                        label="Correo" required margin email pattern>
                        <InputItem placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: "center" }}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 && (
                  <div style={{ textAlign: "center", marginTop: 5 }}>
                    <ButtonItem type="primary" onClick={() => add()} icon={<PlusOutlined />}>
                      Agregar
                    </ButtonItem>
                  </div>
                )}
              </>
            )}
          </FormInitial.List>
          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
              <ButtonItem type="primary" htmlType="submit">Mandar Correo</ButtonItem>
              <ButtonItem type="primary" danger onClick={this.cerrarModal.bind(this)}>Cancelar</ButtonItem>
            </Space>
          </div>
        </Form>
        <iframe
          title="apartadoPdf"
          style={{ width: "100%", height: "100vh" }}
          id="apartadoPdf"
          name="apartadoPdf"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EnviarCorreoApartarVenta);